import { AbilityBuilder, createMongoAbility } from "@casl/ability";

import { Ability } from "../../models/permissions";
import { AbilityService } from "./ability";

const abilityBuilder = new AbilityBuilder<Ability>(createMongoAbility);

export default new AbilityService(abilityBuilder);
